import styled from 'styled-components';

import { deviceSize } from '../../../utils/deviceSize';
import placeholder from '../../../assets/imgs/placeholder.png';

type ImageProps = {
	source?: string;
	isCircle?: boolean;
	selected?: boolean;
};

export const Image = ({
	source,
	selected = false,
	isCircle = false
}: ImageProps): JSX.Element => {
	return (
		<Container $selected={selected} $isCircle={isCircle}>
			<img
				src={source ? source : placeholder}
				alt="store_image"
				className="card-img-left8"
			/>
		</Container>
	);
};

const Container = styled.div<IImage>`
	border: 1px solid #f47920;
	border-color: ${({ $selected }) => ($selected ? ' #f47920' : 'unset')};
	border-radius: 50%;
	height: 60px;
	width: 60px;
	overflow: hidden;
	display: flex;
	align-items: center;
	justify-content: center;

	/* @media (max-width: ${deviceSize.sm}) {
		height: 80px;
		width: 80px;
	} */
	img {
		object-fit: cover;
		border-radius: ${props => (props.$isCircle === true ? '50%' : 'none')};
		width: 100%;
		height: 100%;
		/* height: ${props => (props.$isCircle === true ? '100px' : '220px')};
		width: ${props => (props.$isCircle === true ? '100px' : '180px')}; */
		@media (max-width: ${deviceSize.sm}) {
			height: ${props => (props.$isCircle === true ? '100px' : '140px')};
			width: ${props => (props.$isCircle === true ? '100px' : '100px')};
		}
	}
`;

interface IImage {
	$selected?: boolean;
	$isCircle?: boolean;
}

// export { Image };
